import { Alert, Button, Col, Form, Upload } from "antd";
import { InboxOutlined, UploadOutlined } from "@ant-design/icons";
import FormButton from "./FormButton";
import Dragger from "antd/es/upload/Dragger";
import { useEffect, useState } from "react";

const FormFileUpload = ({
  id,
  type = "file",
  label = "",
  required = false,
  name = "",
  key,
  rules = undefined,
  widthSize = "large",
  form,
  acceptedFileTypes = [],
  max = 0,
  ...rest
}: any) => {
  const spanSize =
    widthSize.toLowerCase() == "large"
      ? 24
      : widthSize.toLowerCase() == "small"
      ? 4
      : 8;
  console.log("Column Width", widthSize.toLowerCase());

  const [fileList, setFileList] = useState<any[]>([]);
  const [alertMessage, setAlertMessage] = useState<string>("");

  useEffect(() => {
    // You can also detect reset by checking form values when the component mounts
    const values = form.getFieldsValue();
    if (Object.keys(values).length === 0) {
      console.log("Form values are empty, it might have been reset");
    }
  }, [form]);

  const handleFileChange = ({ fileList: newFileList }: any) => {
    setFileList(newFileList);
    debugger;

    form.setFieldValue(`${name}`, newFileList);
    const formValue = form.getFieldsValue();
    const fieldNames = Object.keys(formValue); // This will give you the field names
    console.log("All Field Names UploadFile:", fieldNames);
    console.log("Added Field Value UploadFile:", `${name}`, formValue);

    // Check if the number of files exceeds the max count
    if (newFileList.length > max) {
      setAlertMessage(`You can only upload a maximum of ${max} files.`);
    } else {
      setAlertMessage("");
    }
  };

  // Prevent upload if the max file count is reached
  const beforeUpload = (file: any) => {
    if (fileList.length >= max) {
      setAlertMessage(`You can only upload a maximum of ${max} files.`);
      return false;
    }
    return true;
  };

  // Handle drop event to only accept specific file types
  const handleDrop = (e: React.DragEvent) => {
    debugger;
    const droppedFiles = e.dataTransfer.files;
    const invalidFiles: File[] = [];

    // Check each dropped file type
    for (let i = 0; i < droppedFiles.length; i++) {
      const file = droppedFiles[i];
      if (!acceptedFileTypes.includes(file.type)) {
        invalidFiles.push(file);
      }
    }

    if (invalidFiles.length > 0) {
      // Alert the user that some files are invalid
      alert(
        `Please upload files of the following types: ${acceptedFileTypes.join(
          ", "
        )}.`
      );
    }

    console.log("Drop event:", e);
    console.log("Dropped Files:", droppedFiles);
  };
  return (
    <Col span={spanSize}>
      {alertMessage && <Alert message={alertMessage} type="warning" showIcon />}
      <Form.Item
        label={label}
        name={`${name}`}
        rules={rules}
        layout="vertical"
        // wrapperCol={{ span: 24 }}
      >
        {type.toLowerCase() == "file" ? (
          <>
            <Upload
              /*  action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload" */
              listType="picture"
              maxCount={max || undefined}
              multiple
              accept={acceptedFileTypes.join(",")}
              onChange={handleFileChange}
              beforeUpload={beforeUpload} // Check before uploading any file
              onRemove={(file: any) => {
                setAlertMessage("");
              }}
            >
              <FormButton
                icon={<UploadOutlined />}
                label={max > 0 ? `Upload (Max: ${max})` : "Upload"}
              />
            </Upload>

            <label>({acceptedFileTypes.join(" , ")})</label>
          </>
        ) : (
          <>
            <Dragger
              {...rest}
              listType="picture"
              maxCount={max || undefined}
              multiple
              accept={acceptedFileTypes.join(",")}
              onChange={handleFileChange}
              beforeUpload={beforeUpload}
              onRemove={(file: any) => {
                setAlertMessage("");
              }}
              onDrop={handleDrop}
            >
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">
                Click or drag file to this area to upload
              </p>
              <p className="ant-upload-hint">
                Support for a single or bulk upload. Strictly prohibited from
                uploading company data or other banned files.
              </p>
              {max && (
                <p>
                  Maximum {max} {max == 1 ? "file is" : "files are"} allowed
                </p>
              )}
              <p>( {acceptedFileTypes.join(" , ")} )</p>
            </Dragger>
          </>
        )}
      </Form.Item>
    </Col>
  );
};

export default FormFileUpload;
